module.exports = __webpack_public_path__ + "img/terracenew_box29.cb49221f.jpg";